export default __webpack_public_path__ + "static/media/profile.eca6a75c.jpg";